module.exports = __webpack_public_path__ + "assets/img/star_sentence5.a763d05e.png";